import { Check } from 'lucide-react';
import { AppStoreBadge } from '../StoreButtons';

const ALL_FEATURES = [
  'Fly patterns database (70+ patterns)',
  'Regional hatch calendar (7+ regions)',
  'Weather & conditions analysis',
  'AI-powered fly recommendations',
  'My Fly Box',
  'Trip planner',
  'Fishing logbook with GPS & multi-fly tracking',
  'Fish species, length & weight recording (16 species)',
  'Analytics dashboard',
  'Cloud sync across your devices',
];

const PLANS = [
  {
    name: 'Monthly',
    usd: '$6.99',
    cad: '$9.99',
    period: 'per month',
    highlight: false,
  },
  {
    name: 'Annual',
    usd: '$39.99',
    cad: '$49.99',
    period: 'per year',
    highlight: true,
    save: 'Save over 50%',
  },
];

const PricingSection = () => (
  <section id="pricing" className="py-24 bg-[#0b0f13]" data-testid="pricing-section">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-4">
        <span className="inline-block bg-yellow-400 text-slate-900 px-4 py-1 rounded-full text-sm font-bold mb-4">2-WEEK FREE TRIAL</span>
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">Try FlyFinder Free for 2 Weeks</h2>
        <p className="text-lg text-slate-400 max-w-2xl mx-auto">
          Full access to every feature. When your trial ends, keep going with a simple monthly or annual subscription &mdash; cancel anytime.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto items-stretch mt-12">
        {PLANS.map((plan) => (
          <div
            key={plan.name}
            className={`relative rounded-2xl p-8 flex flex-col ${
              plan.highlight
                ? 'bg-gradient-to-br from-[#0c4f7d] to-[#137dc5] border border-[#3aa0e0]/50 shadow-2xl'
                : 'bg-[#1E2328] border border-white/10'
            }`}
          >
            {plan.highlight && plan.save && (
              <div className="absolute top-5 right-5 bg-yellow-400 text-slate-900 px-3 py-1 rounded-full text-xs font-bold">{plan.save}</div>
            )}
            <h3 className="text-2xl font-bold text-white mb-1">{plan.name}</h3>
            {plan.highlight && <p className="text-cyan-100 text-sm mb-4">Best value for serious anglers</p>}
            {!plan.highlight && <p className="text-slate-400 text-sm mb-4">Flexible, pay as you go</p>}

            <div className="mb-2">
              <span className="text-4xl font-bold text-white">{plan.usd}</span>
              <span className={plan.highlight ? 'text-cyan-100' : 'text-slate-400'}> USD {plan.period}</span>
            </div>
            <div className={`text-lg font-semibold mb-6 ${plan.highlight ? 'text-cyan-50' : 'text-slate-300'}`}>
              {plan.cad} CAD {plan.period}
            </div>

            <div className={`flex items-center gap-2 mb-6 text-sm ${plan.highlight ? 'text-cyan-50' : 'text-[#3aa0e0]'}`}>
              <Check className="w-4 h-4 flex-shrink-0" />
              <span>Starts with a 2-week free trial</span>
            </div>

            <div className="mt-auto flex justify-center">
              <AppStoreBadge className="h-14" />
            </div>
          </div>
        ))}
      </div>

      <div className="max-w-4xl mx-auto mt-12">
        <h3 className="text-center text-white font-semibold text-lg mb-6">Every subscription includes</h3>
        <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-3">
          {ALL_FEATURES.map((item) => (
            <li key={item} className="flex items-start gap-3">
              <Check className="w-5 h-5 text-[#3aa0e0] flex-shrink-0 mt-0.5" />
              <span className="text-slate-300">{item}</span>
            </li>
          ))}
        </ul>
      </div>

      <p className="text-center text-slate-500 text-sm mt-10 max-w-2xl mx-auto">
        Start with a 2-week free trial &mdash; Apple handles the countdown and reminds you before it ends. Cancel anytime. Prices may vary slightly by region. Subscribe through the App Store.
      </p>
    </div>
  </section>
);

export default PricingSection;
